import { IRole } from 'interfaces/roles'

const normalize = (value: string) => value.trim().toLocaleLowerCase()

export const isDuplicateRoleName = (
  name: string,
  roles: IRole[],
  excludeRoleId?: number
) => {
  const normalized = normalize(name)
  if (!normalized) return false
  return roles.some(
    (role) =>
      normalize(role.name) === normalized &&
      (excludeRoleId == null || role.id !== excludeRoleId)
  )
}

export const isDuplicateRoleCode = (
  code: string,
  roles: IRole[],
  excludeRoleId?: number
) => {
  const normalized = normalize(code)
  if (!normalized) return false
  return roles.some(
    (role) =>
      normalize(role.code) === normalized &&
      (excludeRoleId == null || role.id !== excludeRoleId)
  )
}
